import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export const orgEditState = {
   parent: 'app',
   name: 'orgEdit',
   url: '/org/:id',
   params: {
      id: {
         squash: true,
         value: null
      }
   },
   templateUrl: require('./org-edit.html'),
   controller: 'OrgEditController as ctrl',
   data: {
      roles: 'SuperAdmin,OrgAdmin',
      nav: {
         title: 'Organization',
         icon: 'e360-icon-organization'
      }
   }
};

export const orgAddState = {
   parent: 'app',
   name: 'orgAdd',
   url: '/org/add',
   templateUrl: require('./org-edit.html'),
   controller: 'OrgEditController as ctrl',
   data: {
      roles: 'SuperAdmin'
   }
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(orgEditState);
   $stateRegistry.register(orgAddState);
}
